import styled from 'styled-components'

export const TooltipContent = styled.div`
  max-width: 300px;
  line-height: 1.4;

  div {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }
`

export const TooltipSection = styled.div`
  margin-bottom: 4px;
`

export const TooltipTitle = styled(TooltipSection)`
  font-weight: 500;
`

export const TooltipOperator = styled.strong`
  font-weight: 600;
`

export const TooltipExample = styled.em`
  font-style: italic;
`

export const TooltipSeparator = styled.div`
  margin: 8px 0;
`

export const TooltipExamplesTitle = styled(TooltipSection)`
  font-weight: 500;
  margin-top: 8px;
`
